import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SegmentedControl, Tooltip } from '@fly/core';

import { DistributionFormRowLayout } from './DistributionFormRowLayout';
import {
  DistributionFormRow,
  distributionRowKey,
} from './distributionFormKeys';
import { getDistributionStatusItems } from './distributionFormUtils';

export function DistributionFormComingSoon({
  comingSoonArtifactVersions,
}: {
  comingSoonArtifactVersions: DistributionFormRow[];
}) {
  const { t } = useTranslation();
  const comingSoonTooltip = t(
    'app.dashboard.artifacts.distribution_form.coming_soon_tooltip',
    {
      defaultValue: 'This artifact type is not yet supported to make public',
    }
  );
  const distributionStatusItems = useMemo(
    () => getDistributionStatusItems(t),
    [t]
  );

  return comingSoonArtifactVersions.map((row) => (
    <DistributionFormRowLayout
      key={distributionRowKey(row)}
      row={row}
      comingSoon
    >
      <Tooltip content={comingSoonTooltip} side='bottom' delayDuration={0}>
        <SegmentedControl
          className='opacity-32'
          variant='surface'
          size='1'
          value='not_allow'
          items={distributionStatusItems}
          data-testid='distribution-segmented-control'
          disabled
          onChange={() => {}}
        />
      </Tooltip>
    </DistributionFormRowLayout>
  ));
}
